module.exports = "pegasus_template/assets/hexagon-linkedin.png";